import type { OpenPosition } from '@flipster/r230522/original/position';

/**
 * close-flip 컬럼의 레이아웃 결정 로직.
 * "airdrop 포지션은 flip(및 일반 close/partial)이 불가"하다는 도메인 규칙을 한 곳에 모아 UI와 분리한다.
 * airdrop 여부는 `airdropType`로 판별한다(null이면 일반 포지션 = flip 가능).
 */

/** flip 가능한 일반(비-airdrop) 포지션이 하나라도 있는지 */
export const containsFlippablePosition = (positions: Pick<OpenPosition, 'airdropType'>[]): boolean =>
  positions.some((position) => position.airdropType === null);

/**
 * close-flip 헤더 라벨 정렬.
 * - 일반 포지션이 섞여 있으면 'Close'/'Flip position' 두 라벨을 양끝(space-between)으로
 * - airdrop만 있으면 'Close' 한 라벨만 우측(flex-end)으로 — 우측 정렬된 close 버튼 위에 얹힘
 */
export const resolveCloseFlipHeaderJustify = (hasFlippablePosition: boolean): 'space-between' | 'flex-end' =>
  hasFlippablePosition ? 'space-between' : 'flex-end';

/**
 * airdrop close 버튼을 'Close' 헤더 아래(close 열)에 맞출지 여부.
 * 혼합(일반 + airdrop) 케이스에서만 true — 이때 CTA 셀은 우측 정렬을 유지하되
 * airdrop 버튼 래퍼를 maxWidth 박스로 넓혀 그 안에서 좌측 정렬한다.
 * airdrop 단일/일반 포지션은 false(래퍼가 우측에 그대로 붙음).
 */
export const shouldAlignAirdropCtaToCloseColumn = ({
  isAirdrop,
  hasFlippablePosition,
}: {
  isAirdrop: boolean;
  hasFlippablePosition: boolean;
}): boolean => isAirdrop && hasFlippablePosition;
